export const ROLES = {
  admin: "Admin",
  service: "Service",
  vask: "Vask",
  kunde: "Kunde",
};

export const STATUS_LABEL = {
  inne: "Inne",
  ute: "Ute",
};

export const DEFECT_STATUS = {
  open: "Åpen",
  in_progress: "Under arbeid",
  resolved: "Løst – arkivert",
  known_issue: "Kjent feil på båt",
};

export const CHECKLIST_TYPE_LABEL = {
  maintenance: "Vedlikehold/Renhold",
  checkin: "Innsjekk",
  checkout: "Utsjekk",
};
